import { api } from '@api/api2';
import type { GetResidentOwnershipStatusPayload } from './types';

export const getResidentOwnershipStatus = (payload: GetResidentOwnershipStatusPayload) =>
  api.v4('get', 'residents-new/support/available-ownership-type', payload);
